<template>
	<div v-if="releaseNotesForm" class="py-8 flex flex-col 2xl:flex-row gap-8 justify-stretch 2xl:items-start">
		<div class="flex-1">
			<FirmwareReleaseNotesForm
					:form="releaseNotesForm"
					@on-save="saveFirmwareReleaseNote"
					:selected-firmware="$attrs.firmware"
			/>
		</div>
		<div class="flex-1">
			<FirmwareReleaseNotesList
					:selected-firmware="$attrs.firmware"
					@on-delete="deleteFirmwareReleaseNote"
					@on-download="downloadFirmwareReleaseNote"
			/>
		</div>
	</div>
</template>

<script>
import FirmwareReleaseNotesForm from "@/Forms/Firmware/FirmwareReleaseNotesForm.vue";
import { mapStores } from "pinia";
import { useFirmwareReleaseNotesStore } from "@/stores/firmwareReleaseNote.js";
import FirmwareReleaseNotesList from "@/Forms/Firmware/FirmwareReleaseNotesList.vue";
import { useDownloadLink } from "@/Composables/DownloadLink.js";

export default {
	name: "FirmwareReleaseNotesView",
	components: {FirmwareReleaseNotesList, FirmwareReleaseNotesForm},
	data() {
		return {
			releaseNotesForm: undefined,
		}
	},
	computed: {
		...mapStores(useFirmwareReleaseNotesStore)
	},
	methods: {
		async saveFirmwareReleaseNote() {
			try {
				const response = await this.releaseNotesForm.submit();
				this.releaseNotesForm.reset();
				this.$toast.add({
					severity: 'success',
					summary: this.$t('common.complete'),
					detail: this.$t('forms.firmware.firmware_release_notes_form.release_note_uploaded'),
					life: 3000
				});
				this.$emit('on-save');
				this.$emit('refresh-firmware');
			} catch (error) {
				this.$toast.add({
					severity: 'error',
					summary: this.$t('common.error'),
					detail: error?.data?.message ?? this.$t('forms.firmware.firmware_release_notes_form.there_was_an_error_uploading_the_release_note'),
					life: 5000
				});
			}
		},
		async deleteFirmwareReleaseNote(firmwareReleaseNote) {
			if (firmwareReleaseNote) {
				await this.firmwareReleaseNotesStore.deleteFirmwareReleaseNote(firmwareReleaseNote.id);
				this.$emit('on-save');
				this.$emit('refresh-firmware');
			}
		},
		async downloadFirmwareReleaseNote(firmwareReleaseNote) {
			if (firmwareReleaseNote) {
				try {
					const response = await this.firmwareReleaseNotesStore.showFirmwareReleaseNote(firmwareReleaseNote.id, { download: 1 });
					useDownloadLink(response.url);
				} catch (error) {
					console.log('Error downloading firmware release note', error);
				}
			}
		}
	},
	watch: {
		'$route.params.firmware': {
			async handler(newValue, oldValue) {
				if (newValue) {
					this.releaseNotesForm = await this.firmwareReleaseNotesStore.createFirmwareReleaseNote();
					this.releaseNotesForm.firmware_id = this.$attrs.firmware.id;
				} else {
					this.releaseNotesForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>